var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint0_linear_433_14803)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint1_linear_433_14803)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_433_14803)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#E2E4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 54.5C38.2009 54.5 33.5 49.7991 33.5 44C33.5 38.2009 38.2009 33.5 44 33.5C49.7991 33.5 54.5 38.2009 54.5 44C54.5 49.7991 49.7991 54.5 44 54.5ZM42.95 44.8316V48.2H45.05V44.8316C45.6027 44.5904 46.0555 44.1662 46.3323 43.6304C46.609 43.0946 46.6928 42.4798 46.5696 41.8894C46.4464 41.2991 46.1237 40.7692 45.6557 40.3888C45.1877 40.0084 44.6031 39.8007 44 39.8007C43.3969 39.8007 42.8123 40.0084 42.3443 40.3888C41.8763 40.7692 41.5536 41.2991 41.4304 41.8894C41.3072 42.4798 41.391 43.0946 41.6677 43.6304C41.9445 44.1662 42.3973 44.5904 42.95 44.8316Z",
    fill: "#525866"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_433_14803",
    x: 12,
    y: 14,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_433_14803"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_433_14803",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_433_14803",
    x1: 44,
    y1: 0,
    x2: 44,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E5E7",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F8F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_433_14803",
    x1: 44,
    y1: 0,
    x2: 44,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E4E5E7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon1);
export default __webpack_public_path__ + "static/media/Custom Icon (1).0c231a595826cf284d448270b154e3b6.svg";
export { ForwardRef as ReactComponent };